import { render, staticRenderFns } from "./ChatHeaderBar.vue?vue&type=template&id=c56a4476&scoped=true"
import script from "./ChatHeaderBar.vue?vue&type=script&lang=js"
export * from "./ChatHeaderBar.vue?vue&type=script&lang=js"
import style0 from "./ChatHeaderBar.vue?vue&type=style&index=0&id=c56a4476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56a4476",
  null
  
)

export default component.exports